import AxiosInstance from '../models/AxiosInstance';

const axiosInstance = new AxiosInstance()

const useAxiosInstance = () => axiosInstance;

export default useAxiosInstance
